export default {"src":"/_next/static/media/shieldIconOutline100_40.f7b3b1ff.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};